import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Badge,Button,Col,Card,CardBody,FormGroup,Input,InputGroup,InputGroupButton,Label,
  PaginationItem,PaginationLink,Row,Table} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const orderStatus = ["Cancelled", "Received","Being Prepared","Out for delivery","Delivered"];
const actionStatus = [];

const generateAddr = (data) => {
  if (!data) {
    return '';
  }
  
  let address = [];
  let address_no = [];

  if (data.building_no) {
    address_no.push(data.building_no);
  }
  if (data.door_no) {
    address_no.push(data.door_no);
  }
  if (address_no.length == 2) {
    address_no = address_no.join('/');
  }
  if (data.neighborhood) {
    address.push(data.neighborhood);
  }
  if (data.street) {
    address.push(data.street);
  }
  if (address_no) {
    address.push(address_no);
  }
  if (data.province) {
    address.push(data.province);
  }
  if (data.city) {
    address.push(data.city);
  }
  address = address.join(', ')
  return address;
}
        
const TableRow = (props) => {
  let status = parseInt(props.data.status);
  let cartAmount = parseFloat(props.data.cartAmount);
  cartAmount = cartAmount.toFixed(2);
  cartAmount = cartAmount.replace('.', ',');

  let date = '';
  if (props.data.order_time) {
    date = new Date(props.data.order_time);
    date = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }
  
  return (
    <tr>
      <td>{props.data.user_name}</td>
      <td>{props.data.user_phone || ''}</td>
      <td>{generateAddr(props.data.user_address)}</td>
      <td><ul>{props.data.cart.map(item=>(
        <li key={item.product_id}>{item.product_name} [x{item.order_count}]</li>
      ))}</ul></td>
      <td>{cartAmount || ''}</td>
      <td>{date}</td>
      <td>{props.data.shop_name || ''}</td>
      <td>{generateAddr(props.data.shop_address)}</td>
      <td><Badge color='primary' onClick={()=>props.changeStatus(props.rowKey,status+1)} style={{cursor:'pointer'}}>{orderStatus[status]}</Badge></td>
      {(props.userType == 1) &&
      <td>
        <Input type="select" onChange={(e) => props.changeStatus(props.rowKey, e.target.value)} defaultValue={props.data.status}>
          <option value='1'>Received</option>
          <option value='2'>Being Prepared</option>
          <option value='3'>Out for delivery</option>
          <option value='4'>Delivered</option>
          <option value='0'>Cancelled</option>
        </Input>
      </td>
      }
    </tr>
  );
}

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Orders extends Component {
  constructor() {
    super();
    this.uid = sessionStorage.getItem("uid");
    this.user_type = sessionStorage.getItem("user_type");
    this.shop_list = '';
    this.city = [], this.province = [], this.neighborhood = [], this.street = [];

    if (this.user_type == 1 || this.user_type == 3) {
      this.shop_list = 'active';
    }

    if (this.user_type == 3) {
      this.area = sessionStorage.getItem('area');
    }

    this.state = {
      modal: false,
      options_shop: [],
      pageOfItems: [],
      rows: [],
      searchRows: [],
      shop_id: '',
      show: 'none'
    };

    this.changeStatus = this.changeStatus.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onShopChange = this.onShopChange.bind(this);
  }

  componentWillMount() {
    if (this.shop_list == 'active') {
      this.createShopOption();
    }

    if (this.user_type == 3) {
      this.loadLocation();
    }
    else {
      this.loadOrders('');
    }
  }

  changeStatus(key, status){
    status = parseInt(status);
    if (status < 5) {
      if (this.user_type == 1) {
        app.database().ref('orders/'+key).update({status});
      }
      else {
        if ((this.user_type == 2 && status == 2) || (this.user_type == 3 && status>=3)) {
          app.database().ref('orders/'+key).update({status});
        }
      }
    }
  }

  createShopOption() {
    let result = [];
    app.database().ref('users').orderByChild('user_type').equalTo(2).once('value', (snapshot)=>{
      snapshot.forEach((child)=>{
        if ((child.val().user_name != '') && (child.val().shop_name !== undefined)) {
          let data = {};
          data.key = child.key;
          data.user_name = child.val().user_name;
          data.shop_name = child.val().shop_name;
          result.push(data);
        }
      });
    })
    .then(()=>{
      let options = [];
      result.sort(function(a,b) {return (a.user_name > b.user_name) ? 1 : ((b.user_name > a.user_name) ? -1 : 0);});
      for (let i = 0, len = result.length; i < len; i++) {
        options.push(<option key={result[i].key} value={result[i].key}>{result[i].user_name+' ('+result[i].shop_name+')'}</option>);
      }
      this.setState({
        options_shop: options
      });
    })
    .catch((error)=>{
      console.log(error.message);
    });
  }

  filterData(searchText, element){
    return (element.props.data.user_name.toLowerCase().indexOf(searchText) != -1)
  }

  generateRow(orders) {
    let rows = [];
    for (let key in orders) {
      rows.push(<TableRow key={key} data={orders[key]} rowKey={orders[key].key} changeStatus={this.changeStatus} userType={this.user_type} />);
    }
    this.setState({
      rows:rows,
      searchRows: rows
    });
  }

  loadLocation() {
    app.database().ref('locations').orderByChild('area_code').equalTo(this.area).once('value')
    .then((snapshot)=>{
      snapshot.forEach((child)=>{
        let value = child.val();
        if (this.city.indexOf(value.city) == -1) {
          this.city.push(value.city);
        }
        if (this.province.indexOf(value.province) == -1) {
          this.province.push(value.province);
        }
        if (this.neighborhood.indexOf(value.neighborhood) == -1) {
          this.neighborhood.push(value.neighborhood);
        }
        if (this.street.indexOf(value.street) == -1) {
          this.street.push(value.street);
        }
      });

      this.loadOrders(null);
    });
  }

  loadOrders(shop_id) {
    let products = [];
    if (this.user_type == 2) {
      shop_id = this.uid;
    }

    if (shop_id != '') {
      app.database().ref('orders').orderByChild('shop_id').equalTo(shop_id).on('value', (snapshot)=>{
        let orders = [], data;
        snapshot.forEach((child)=>{
          data = child.val();
          if ((this.user_type != 3) || ((this.city.indexOf(data.user_address.city) != -1) &&
            (this.province.indexOf(data.user_address.province) != -1) &&
            (this.neighborhood.indexOf(data.user_address.neighborhood) != -1) &&
            (this.street.indexOf(data.user_address.street) != -1))) {
            data.key = child.key;
            orders.push(data);
          }
        });

        orders.sort((a,b)=>{return (a.order_time<b.order_time)? 1 : ((b.order_time<a.order_time)? -1:0)});
        this.generateRow(orders);
      });
    }

    if (shop_id == '') {
      app.database().ref('orders').on('value', (snapshot)=>{
      let orders = [], data;
      snapshot.forEach((child)=>{
        data = child.val();
        if ((this.user_type != 3) || ((this.city.indexOf(data.user_address.city) != -1) &&
          (this.province.indexOf(data.user_address.province) != -1) &&
          (this.neighborhood.indexOf(data.user_address.neighborhood) != -1) &&
          (this.street.indexOf(data.user_address.street) != -1))) {
          data.key = child.key;
          orders.push(data);
        }
      });

      orders.sort((a,b)=>{return (a.order_time<b.order_time)? 1 : ((b.order_time<a.order_time)? -1:0)});
      this.generateRow(orders);
    });
    }
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    var rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  onShopChange(event) {
    let shop_id = event.target.value;
    this.setState({
      shop_id: shop_id
    }, ()=>this.loadOrders(shop_id));
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <FormGroup row>
                  {
                    (this.shop_list == 'active') &&
                    <Col md="3">
                      <InputGroup className="mb-3">
                        <Input type="select" name="shop_list" innerRef={(input) => { this.shopInput = input }} onChange={this.onShopChange}>
                          <option value="">Select Shop</option>
                          {this.state.options_shop}
                        </Input>
                      </InputGroup>
                    </Col>
                  }
                  <Col md="3">
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.searchForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter text here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </Col>
                </FormGroup>
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>User Name</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Items</th>
                    <th>Total</th>
                    <th>OrderTme</th>
                    <th>Shop Name</th>
                    <th>Shop Address</th>
                    <th>Status</th>
                    {(this.user_type == 1) &&
                    <th>Action</th>
                    }
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Orders;


// WEBPACK FOOTER //
// ./src/views/Orders/Orders.js